import { Grid, Box } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";
import WarningIcon from '@mui/icons-material/Warning';
import ReportProblemIcon from '@mui/icons-material/ReportProblem'; 

function NoAprobado2() {
    return (
        <Grid container py={3}>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
                <WarningIcon sx={{ fontSize: "large", color: "orange" }} />
            </Grid>

            <Grid item xs={12} pb={0}>
                <SoftTypography variant="h6" sx={{ textAlign: "center" }} mb={2}>
                    Información Importante
                </SoftTypography>
            </Grid>
            <Grid item xs={12} pb={2}>
                <Box display="flex" alignItems="center" sx={{ color: "red", mb: 2 }}>
                    <ReportProblemIcon sx={{ mr: 1 }} />
                    <SoftTypography
                        variant="caption"
                        component="p"
                        sx={{
                            textAlign: "justify",
                            fontWeight: 500,
                            fontSize: "0.85rem",
                            m: 0,
                            color: "red",
                        }}
                    >
                        Recuerde que es obligatorio completar el campo <strong>&quot;Plazo de entrega en días corridos&quot;</strong> en todas las cotizaciones.
                    </SoftTypography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <SoftTypography
                    variant="caption"
                    component="p"
                    color="text"
                    sx={{ textAlign: "justify", fontSize: "0.85rem" }}
                    mb={2}
                >
                    Para poder participar en las cotizaciones, es necesario que su documentación esté al día y haya sido aprobada por el área de Compras.
                </SoftTypography>

                <SoftTypography
                    variant="caption"
                    component="ul"
                    color="text"
                    sx={{ textAlign: "justify", listStyleType: "disc", pl: 3, fontSize: "0.85rem" }}
                    mb={2}
                >
                    <li>
                        Si ya ha completado la documentación, espere a que sea aprobada, o verifique si está vencida.
                    </li>
                    <li>
                        Puede seguir el estado de su documentación en la sección &quot;Perfil&quot;.
                    </li>
                    <li>
                        Si tiene alguna consulta o necesita asistencia, por favor comuníquese con el área de Administración del Comedor.
                        <br />
                        Email:{" "}
                        <a href="mailto:comedorupro@uprosanluis.edu.ar" style={{ textDecoration: "none", color: "blue" }}>
                             comedorupro@uprosanluis.edu.ar
                        </a>
                    </li>
                </SoftTypography>

                <SoftTypography
                    variant="caption"
                    component="p"
                    color="text"
                    sx={{ textAlign: "justify" }}
                >
                    Si su documentación está al día y aprobada, desestime este mensaje.
                </SoftTypography>
            </Grid>
        </Grid>
    );
}

export default NoAprobado2;
